import React, { useRef, useEffect } from 'react';
import { $generateHtmlFromNodes } from '@lexical/html';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { OnChangePlugin } from '@lexical/react/LexicalOnChangePlugin';

export default function OnChangeHTMLPlugin({ onChange, skipInitial = true }) {
  const [editor] = useLexicalComposerContext();
  const lastHtml = useRef('');
  const isInitialized = useRef(!skipInitial);

  useEffect(() => {
    if (!isInitialized.current) {
      const timer = setTimeout(() => {
        isInitialized.current = true;
      }, 100);

      return () => clearTimeout(timer);
    }

    return undefined;
  }, []);

  const handleChange = (editorState) => {
    if (!isInitialized.current) return;

    editorState.read(() => {
      const html = $generateHtmlFromNodes(editor, null);
      const cleanHTML = html
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&');

      if (cleanHTML !== lastHtml.current) {
        lastHtml.current = cleanHTML;
        onChange(cleanHTML);
      }
    });
  };

  return <OnChangePlugin onChange={handleChange} />;
}
